module.exports = __webpack_public_path__ + "img/ico_xsgzgl.fec44fe6.png";